// @flow
import { Record } from "immutable"

type InputType = {
  name: string,
  code: string,
  price: number,
  booking_url: ?string,
  source: string,
}

const JourneyProviderRecord = Record({
  name: "",
  code: null,
  price: null,
  bookingUrl: null,
  source: null,
})

export default class JourneyProvider extends JourneyProviderRecord {
  static fromPlainJS(input: InputType) {
    return new JourneyProvider({
      name: input.name,
      code: input.code,
      price: parseFloat(input.price),
      bookingUrl: input.booking_url,
      source: input.source,
    })
  }
}
